import * as React from 'react';

import PropTypes from 'prop-types';

import { getNavigateLogEntry } from '../../../util/helper';

import { useRouter } from '../../../util/hook/custom';
import useEffect from '../../../util/hook/useEffect';
import useSelector from '../../../util/hook/useSelector';
import useState from '../../../util/hook/useState';

import { selectLiffId, selectLogSessionToken } from '../../../util/redux/auth';

import { entryAPI } from '../../../api/log';

import { S } from './style';

import { NOT_FOUND_PAGE_REDIRECT_COUNTDOWN_SECOND } from '../../../config/ui/time';

import notFoundImg from '../../../asset/image/pageNotFound.svg';

import ConfigHeader from '../../helper/ConfigHeader';

/* log error */
const useLogError = ({
  _id,
  logSessionToken,
  level,
  msg,
  payload,
}: {
  _id: string;
  logSessionToken: string;
  level: string;
  msg: string;
  payload: any;
}) => {
  useEffect(() => {
    if (logSessionToken) {
      entryAPI.Post({
        _id,
        sessionToken: logSessionToken,
        log: {
          level,
          msg,
          payload,
        },
      });
    }
  }, []);
};

/* countdown to redirect */
const useCountdownRedirect = ({
  redirectRoute,
  countdownSecond,
  setSecond,
  navigate,
}: {
  redirectRoute?: string;
  countdownSecond: number;
  setSecond: React.Dispatch<React.SetStateAction<number>>;
  navigate: Function;
}) => {
  useEffect(() => {
    if (!redirectRoute) return;

    const intervalId = setInterval(() => {
      setSecond((prev) => prev - 1);
    }, 1000);

    if (countdownSecond === 0) {
      clearInterval(intervalId);
      navigate(redirectRoute);
    }

    // eslint-disable-next-line consistent-return
    return () => {
      clearInterval(intervalId);
    };
  }, [countdownSecond]);
};

export default function NotFound({ redirectRoute }: { redirectRoute?: string }) {
  const [countdownSecond, setSecond] = useState(NOT_FOUND_PAGE_REDIRECT_COUNTDOWN_SECOND);

  const _id = useSelector(selectLiffId);
  const logSessionToken = useSelector(selectLogSessionToken);

  const { useLocation, navigate } = useRouter();
  const location = useLocation();
  const sourceRoute = location.pathname;

  const { level, msg, payload } = getNavigateLogEntry(sourceRoute, '/notFound');

  useLogError({ _id, logSessionToken, level, msg, payload });
  useCountdownRedirect({ redirectRoute, countdownSecond, setSecond, navigate });

  return (
    <S.Wrapper>
      <ConfigHeader />
      <S.Img alt='notFound' src={notFoundImg} />
      {redirectRoute ? (
        <S.Countdown>將於倒數 {countdownSecond} 秒後自動導回首頁</S.Countdown>
      ) : (
        '找不到頁面'
      )}
    </S.Wrapper>
  );
}

NotFound.propTypes = {
  redirectRoute: PropTypes.string,
};
